<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm9 md6 lg4>
      <v-card class="RequestPasswordResetCard">
        <v-card-title primary-title class="RequestPasswordResetCard-title">
          <img src="/images/logo_text.png" alt="logo explorama" />
          <p v-if="!hasValidate">{{ $t('requestResetPassword.subtitle') }}</p>
        </v-card-title>
        <v-form
          @submit.prevent="doRequestResetPassword"
          id="RequestResetPasswordForm"
          ref="form"
        >
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="email"
                  v-if="!hasValidate"
                  :rules="getEmailRules()"
                  :label="$t('login.username')"
                  type="email"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-alert type="error" :value="errorMessage" outline>{{
                  translatedError
                }}</v-alert>
                <v-alert type="success" :value="hasValidate" outline>{{
                  $t('requestResetPassword.goToEmail')
                }}</v-alert>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              type="submit"
              form="RequestResetPasswordForm"
              class="RequestPasswordResetCard-LoginBtn"
              v-if="!hasValidate"
              >{{ $t('requestResetPassword.submitLabel') }}</v-btn
            >
            <v-btn
              color="primary"
              class="RequestPasswordResetCard-LoginBtn"
              v-if="hasValidate"
              @click="$router.push('/login')"
              >{{ $t('requestResetPassword.backLabel') }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'RequestResetPassword',
  data() {
    return {
      email: '',
      errorMessage: '',
      hasValidate: false,
    };
  },
  computed: {
    translatedError() {
      //if (this.errorMessage.match(/Unable to find users with id/)) {
      //  return this.$t('requestResetPassword.errors.badCredentials');
      //}
      return this.$t('requestResetPassword.errors.badCredentials');
    },
  },
  methods: {
    getEmailRules() {
      return [
        (email) => Boolean(email) || this.$t('login.errors.emailRequired'),
        (email) =>
          /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/.test(
            email
          ) || this.$t('login.errors.emailInvalid'),
      ];
    },
    async doRequestResetPassword() {
      this.hasValidate = false;
      this.errorMessage = '';
      if (!this.$refs.form.validate()) {
        return;
      }
      try {
        const res = await this.$kuzzle.query({
          controller: 'reset-password',
          action: 'requestReset',
          body: {
            email: this.email,
          },
        });
        this.hasValidate = true;
      } catch (e) {
        this.errorMessage = e.message;
        console.error(e.message);
      }
    },
  },
};
</script>

<style scoped lang="sass">
.RequestPasswordResetCard
  &-title
    img
      width: 25em
      margin-bottom: 2em
  &-LoginBtn
    margin: 0
</style>
